/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const GreatValue = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 12 13" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M9.7 3.3A1.202 1.202 0 1 0 8 5a1.202 1.202 0 0 0 1.7-1.7zm-5.4 9.5L.2 8.7a.7.7 0 0 1 0-1L6 1.8c.3-.3.7-.5 1.1-.6L8.5 1s2.3-.2 2.8.3l.3.3c.5.5.3 2.8.3 2.8l-.2 1.4c-.1.4-.3.8-.6 1.1l-5.8 5.9a.7.7 0 0 1-1 0z" fillRule="nonzero" />
      </g>
    </svg>
  </span>
);

GreatValue.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

GreatValue.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default GreatValue;
